module.exports = __webpack_public_path__ + "static/sheet-fc5b115139108dbb8487a13074d39b00.pdf";